// removed by extract-text-webpack-plugin
module.exports = {"header_customer":"styles__header_customer___3qbpK"};


//////////////////
// WEBPACK FOOTER
// ./src/scenes/FixedVoice/components/MyCustomers/styles.css
// module id = 3188
// module chunks = 0